let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("goesq")).then(() => parcelRequire('hIRsw'));